/* =========================================================
   fj-bottle-3d.js
   Reveal logic for snippets/fj-bottle-3d.liquid.

   A custom element initialises itself whenever it is added to the
   page, including theme editor section re-renders, so no
   shopify:section:load handling is needed here.
   ========================================================= */

if (!customElements.get('fj-bottle-3d')) {
  class FjBottle3d extends HTMLElement {
    connectedCallback() {
      if (this.isInitialised) return;
      this.isInitialised = true;

      this.modelViewer = this.querySelector('model-viewer');
      if (!this.modelViewer) return;

      // Strip the poster Shopify auto-generates. Belt-and-suspenders: this
      // works even if the Liquid-level `poster: ''` override isn't in place,
      // and even if model-viewer already upgraded and read the attribute
      // once, since `poster` reactively syncs via its property.
      this.modelViewer.removeAttribute('poster');
      this.modelViewer.poster = '';

      this.reveal = this.reveal.bind(this);
      this.modelViewer.addEventListener('poster-dismissed', this.reveal, { once: true });
      this.modelViewer.addEventListener('load', this.reveal, { once: true });

      // The model may already be loaded (e.g. from cache) before this ran.
      if (this.modelViewer.loaded) this.reveal();
    }

    reveal() {
      this.classList.add('is-revealed');
    }
  }

  customElements.define('fj-bottle-3d', FjBottle3d);
}
